export default function Week1524(props) {
    return (
        <div class="card shadow-lg p-6 bg-base-100">
            <div class="card-body space-y-6">
                <img class="object-cover h-72 w-72 m-auto" src="https://dmxvtdt4jwgem.cloudfront.net/wp-content/uploads/2024/05/Zach-Charbonnet.jpg" />

                <h2 class="text-2xl font-bold ">Player Projections Powered by Vegas Player Props - Week 15</h2>
                <h2 class=" text-sm pr-8 pl-8">By Sang Han</h2>
                <div class="flex justify-center items-center space-x-4">
                    <button class="btn btn-primary" id="prevBtn" onClick={props.movePastWeek}>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="w-5 h-5">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
                        </svg>
                    </button>
                    <h2 class=" text-sm pr-8 pl-8">December 21, 2024</h2>
                    <button class="btn  btn-disabled" id="nextBtn" onClick={props.moveNextWeek}>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="w-5 h-5">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
                        </svg>
                    </button>
                </div>
                                <a class="underline" href="https://www.reddit.com/r/fantasyfootball/comments/1hed1wi/player_projections_powered_by_vegas_player_props/">
                    Original Reddit Post Link
                </a>
                <p class="text-lg">
                    Colors and light.  We all perceive reality through senses honed by millennia of evolution.  The way our eyes respond to light has been unintentionally molded into its current state, as for survival we need to be able to precisely discern threats.  After a generation of no war in America, we have the freedom to direct this perspective to the NFL, and create fantasy rosters based on what we see.
                </p>
                <p class="text-lg">
                    There exists a wide range of potential fantasy theories. One of my league mates spent 150/200 of his auction budget, yet cruised into the playoffs winning multiple weekly high scores along the way.  I drafted the infamous zero RB strat then completely pivoted into trading for RB1s.  We all view the same scenarios, but our brains conjure different game plans.  Arguably, it’s beneficial to test the limits of your wildest theories, or else how do you know they wouldn’t have worked.
                </p>
                <p class="text-lg">
                    Assist the determination of your gameplan through visiting VegasProjections.com, your selfless teammate dedicated to your fantasy success.  All figures are dictated by market odds, and the default drop-down options parse data from a wide array of sportsbooks to spit out a consensus projection.  It’s hard to not agree with MIT PhD quants whose monstrous salaries depends on their predictive accuracies.
                </p>
                <p class="text-lg">
                    Top rated skill players projected over 14 this week include:
                </p>
                <p class="text-lg">
                    Alvin Kamara 20.47
                </p>
                <p class="text-lg">
                    Zach Charbonnet 17.78
                </p>
                <p class="text-lg">
                    Ja'Marr Chase 17.41
                </p>
                <p class="text-lg">
                    Puka Nacua 17.01
                </p>
                <p class="text-lg">
                    Saquon Barkley 16.91
                </p>
                <p class="text-lg">
                    Bijan Robinson 16.64
                </p>
                <p class="text-lg">
                    Joe Mixon 16.25
                </p>
                <p class="text-lg">
                    James Conner 16
                </p>
                <p class="text-lg">
                    Chase Brown 15.76
                </p>
                <p class="text-lg">
                    Chuba Hubbard 15.33
                </p>
                <p class="text-lg">
                    Jahmyr Gibbs 15.09
                </p>
                <p class="text-lg">
                    Nico Collins 15
                </p>
                <p class="text-lg">
                    Justin jefferson 14.66
                </p>
                <p class="text-lg">
                    Amon-Ra St. Brown 14.64
                </p>
                <p class="text-lg">
                    Jaxon Smith-Njiba 14.38
                </p>
                <p class="text-lg">
                    Kyren Williams 14.22
                </p>
                <p class="text-lg">
                    Josh Jacobs 14.1
                </p>
                <p class="text-lg">
                    This week we see that Josh Allen has elevated into a 25 point Lamar, while Lamar lags slightly behind. And Brock Purdy continues to cement himself as a similar late round league winner like Jayden and AR.  Zach Charbonnet has exploded into the second highest flex projection, supporting any thoughts that he deserves to start over Ken.  Chase Brown continues to do his thing, while Alvin Kamara’s Mean Projection using Recent Data has fallen back down to earth.  This recent data mean projection column may be more relevant for players who have recently acquired a primary role, or when circumstances change.  Reminder, mean projections are matchup agnostic, whereas median projections aren’t.  Ladd seems to be playing as his props are all available, and DJ Moore and Keenan seem poised for success.  Engram owners should look to pivot to Ferguson or Ertz.
                </p>
                <p class="text-lg">
                    I just want to give my thanks to the teachers throughout my life that predicated this post. From the English teachers providing me grammar and language mastery to the social studies teachers showing me how Roe v Wade was important.  Without question the math and science teachers to discern the truths in the universe.  Amazingly, there was a fantasy football post on ESPN this week that followed our existential and facts over feelings themes.  She’s an incredible writer compared to me so I was blown away by how much better of a job she did.  Check it out!
                </p>
                <p class="text-lg">
                    It’s playoff time, where legends are made or seasons turn to dust. It’s the witching hour of the playoff season.  Bring it home.
                </p>
            </div>
        </div>
    );
}
